module.exports = "// CUBE ANALYTICS INIT\n$(function(){\n\tvar intervalGAInitID;\n\tfunction initGAFramework() {\n\t\tif (typeof GAFramework !== \"undefined\") {\n\t\t\tclearInterval(intervalGAInitID);\n\t\t\tCUBE.Analytics.init();\n\t\t}\n\t}\n\t\n\tintervalGAInitID = window.setInterval(initGAFramework, 1000);\n});"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/analytics/legacy/framework/anly-init.legacy.js
// module id = 812
// module chunks = 31